// extracted by mini-css-extract-plugin
module.exports = {"other-players-section":"other-players-section_other-players-section__WgpHH"};